// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1OVqW","loadAnimation":"Mcz-g"};